export default "__VITE_ASSET__DQ0P4vfD__"